// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let DevicePixelRatio = require("../v5/common/DevicePixelRatio.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_response_removeTeamMarketingProfileLogo(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["TeamMarketingProfileLogoRemoved"]);
}

let variablesConverter = {};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"removeTeamMarketingProfileLogo_TeamMarketingProfileLogoRemoved_marketingProfile":{"f":""},"removeTeamMarketingProfileLogo":{"u":"response_removeTeamMarketingProfileLogo"}}};

let wrapResponseConverterMap = {
  response_removeTeamMarketingProfileLogo: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

let responseConverter = {"__root":{"removeTeamMarketingProfileLogo_TeamMarketingProfileLogoRemoved_marketingProfile":{"f":""},"removeTeamMarketingProfileLogo":{"u":"response_removeTeamMarketingProfileLogo"}}};

let responseConverterMap = {
  response_removeTeamMarketingProfileLogo: unwrap_response_removeTeamMarketingProfileLogo
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

let Utils = {};

let providedVariablesDefinition = {
  __relay_internal__pv__DevicePixelRatio: {
    providedVariable: DevicePixelRatio.get,
    get: DevicePixelRatio.get
  }
};

function makeNode(providedVariablesDefinition) {
  return ((function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "TeamMarketingProfileLogoForm_RemoveMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "removeTeamMarketingProfileLogo",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TeamMarketingProfile",
                "kind": "LinkedField",
                "name": "marketingProfile",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "TeamMarketingProfileLogoForm_teamMarketingProfile"
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "TeamMarketingProfileLogoRemoved",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__DevicePixelRatio"
      }
    ],
    "kind": "Operation",
    "name": "TeamMarketingProfileLogoForm_RemoveMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "removeTeamMarketingProfileLogo",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TeamMarketingProfile",
                "kind": "LinkedField",
                "name": "marketingProfile",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProfilePhoto",
                    "kind": "LinkedField",
                    "name": "logo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "ratio",
                            "variableName": "__relay_internal__pv__DevicePixelRatio"
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "url",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "nodeId",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "TeamMarketingProfileLogoRemoved",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "501e2da2751860d8af81186b497a05cf",
    "id": null,
    "metadata": {},
    "name": "TeamMarketingProfileLogoForm_RemoveMutation",
    "operationKind": "mutation",
    "text": "mutation TeamMarketingProfileLogoForm_RemoveMutation(\n  $__relay_internal__pv__DevicePixelRatio: Float!\n) {\n  removeTeamMarketingProfileLogo {\n    __typename\n    ... on TeamMarketingProfileLogoRemoved {\n      marketingProfile {\n        ...TeamMarketingProfileLogoForm_teamMarketingProfile\n        nodeId\n      }\n    }\n  }\n}\n\nfragment TeamMarketingProfileLogoForm_teamMarketingProfile on TeamMarketingProfile {\n  logo {\n    url(ratio: $__relay_internal__pv__DevicePixelRatio)\n  }\n}\n",
    "providedVariables": providedVariablesDefinition
  }
};
})());
}

let node = makeNode(providedVariablesDefinition);

let wrap_response_removeTeamMarketingProfileLogo = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_removeTeamMarketingProfileLogo = unwrap_response_removeTeamMarketingProfileLogo;
exports.wrap_response_removeTeamMarketingProfileLogo = wrap_response_removeTeamMarketingProfileLogo;
exports.Internal = Internal;
exports.Utils = Utils;
exports.providedVariablesDefinition = providedVariablesDefinition;
exports.node = node;
/* node Not a pure module */
